import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startPictureUpload, startUpdateNote } from '../../actions/notes'

const NoteAppBar = () => {

    const dispatch = useDispatch()
    const { active } = useSelector(state => state.notes)

    const handleSave = () => {
        dispatch(startUpdateNote(active))
    }

    const handleFileSelector = (e) => {
        const file = e.target.files[0]

        if (file) {
            dispatch(startPictureUpload(file))
        }
    }

    const handlePictureUpload = () => {
        document.querySelector('#fileSelector').click()
    }

    return (
        <div className='notes__appbar'>
            <span>12 de Abril 2022</span>

            <input 
                type="file"
                name="file"
                id="fileSelector"
                onChange={ handleFileSelector }
                style={{ 'display': 'none' }}
            />

            <div>
                <button 
                    className="btn"
                    onClick={ handlePictureUpload }
                >
                    Picture
                </button>

                <button 
                    className="btn"
                    onClick={ handleSave }
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default NoteAppBar